'use es6';

import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import SidebarCardError from 'customer-data-sidebar/SidebarCardError';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from './AsyncComponentErrorHandler';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import wrapWithMarks from './wrapWithMarks';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingCardWrapper = styled.div.withConfig({
  displayName: "makeAsyncCard__LoadingCardWrapper",
  componentId: "sc-1wrsdd2-0"
})(["height:250px;"]);
const DefaultLoadingComponent = () => /*#__PURE__*/_jsx(TFlex, {
  align: "center",
  justify: "center",
  position: "relative",
  children: /*#__PURE__*/_jsx(LoadingCardWrapper, {
    children: /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    })
  })
});

// cardType?: CardType
export function makeAsyncCard({
  cardType,
  chunkName,
  loader
}, LoadingComponent = DefaultLoadingComponent) {
  const actualLoader = cardType ? wrapWithMarks(cardType, 'content', loader) : loader;
  const handleError = AsyncComponentErrorHandler(chunkName);
  let retries = 1;
  return Loadable({
    loader: actualLoader,
    LoadingComponent,
    ErrorComponent: ({
      error,
      retry
    }) => {
      handleError(error);
      if (retries > 0) {
        retry();
        retries -= 1;
        return /*#__PURE__*/_jsx(LoadingComponent, {});
      } else {
        return /*#__PURE__*/_jsx(SidebarCardError, {});
      }
    }
  });
}